import axiosClient from './axiosClient'

const prefixPath = '/ticket'
const reportTicketApi = {
  getList: async (params) => axiosClient.get(`${prefixPath}/list`, { params }),
}

export default reportTicketApi
